import { useDebounce } from '@uidotdev/usehooks';
import { CandidateBatchStatus } from 'generated-graphql/types';
import { useRecoilValue } from 'recoil';
import { organizationAtom } from 'services/organization/atom';
import { userAtom } from 'services/user/atoms';
import { STATUS_FILTER_ID, AnalysisFilter } from '../constants/filters';
import { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAnalysisFilterLabel } from '../utils/getAnalysisFilterLabel';
import { getAnalysesFilter } from '../utils/getAnalysesFilter';

type Props = {
  isAllCampaigns: boolean;
  searchText: string;
};

export const useAnalysesFilters = ({ isAllCampaigns, searchText }: Props) => {
  // Initialize filters from URL
  const [searchParams] = useSearchParams();

  const initialFilters = useMemo(() => {
    const statusFilter = searchParams.get(
      STATUS_FILTER_ID
    ) as CandidateBatchStatus | null;

    const filters: AnalysisFilter[] = [];

    if (statusFilter) {
      filters.push({
        filterId: STATUS_FILTER_ID,
        value: statusFilter,
        label: getAnalysisFilterLabel(statusFilter)
      });
    }

    return filters;
  }, [searchParams]);

  const [filters, setFilters] = useState<AnalysisFilter[]>([]);

  useEffect(() => {
    if (initialFilters.length) {
      setFilters(initialFilters);
    }
  }, [initialFilters]);
  const organization = useRecoilValue(organizationAtom);
  const user = useRecoilValue(userAtom);

  const statusFilter = filters.find(
    (filterItem) => filterItem.filterId === 'status'
  );

  const debouncedSearchRoleValue = useDebounce(searchText, 500);

  const filter = getAnalysesFilter({
    organizationId: organization?.id ?? '',
    userId: user?.id,
    isAllCampaigns,
    statusFilter: statusFilter?.value,
    searchText: debouncedSearchRoleValue
  });

  return {
    filter,
    isFiltering: debouncedSearchRoleValue.length > 0,
    filters,
    setFilters
  };
};
